/**
 * The ARIA label for the navigation toolbar.
 *
 * @defaultValue `""`
 * @group Labels
 * @see https://daypicker.dev/docs/translation#aria-labels
 */
export function labelNav(): string {
  return "";
}
